export default __webpack_public_path__ + "static/media/upto30.98f4682b.png";